package com.eladfinish.bible.contest.platform

import kotlinx.datetime.LocalDate
import kotlinx.datetime.number

/**
 * The date this build of the app was compiled, for the "last updated" caption of the settings
 * screen's version row. The source is [SharedBuildInfo.BUILD_DATE], generated by
 * `generateSharedBuildInfo` in `shared/build.gradle.kts` on every build.
 */
object BuildDate {

    /** `DD/MM/YYYY`, the format the settings screen shows. */
    fun display(): String = toDisplay(SharedBuildInfo.BUILD_DATE)

    /** Converts an ISO-8601 date (`yyyy-MM-dd`) to `DD/MM/YYYY`; an unparsable input is returned as is. */
    internal fun toDisplay(isoDate: String): String {
        val date = runCatching { LocalDate.parse(isoDate) }.getOrNull() ?: return isoDate
        val day = date.day.toString().padStart(2, '0')
        val month = date.month.number.toString().padStart(2, '0')
        return "$day/$month/${date.year}"
    }
}
